import axios from 'axios';

const Category = {
    content: null,
    items: [],
    images: [],
    active: false,
    timeout: null,
    init: () => {
        Category.getData();
    },
    getData: async () => {
        axios
            .get("https://0x000.ch/ecstudio/wp/wp-json/custom_rest_api/v1/get_all_category", { params: { lang: 'it' } })
            .then(function(response) {
                Category.items = response.data;
                Category.render();
            })
    },
    render: () => {
        //preload image
        Category.items.forEach(function(item, index) {
            if (item.image) {
                console.log(item)
                let img = new Image();
                img.src = item.image.url;
                img.onload = function() { console.log(item.image.sizes.large + 'loaded') };
                Category.images[item.slug] = img;
            }
        });

        Category.bind();
    },
    bind: () => {
        let timeout = null;
        let categoryHoverItems = document.querySelectorAll('.category-hover-item');
        let idContent = 0;
        categoryHoverItems.forEach(function(item, index) {
            Category.active = true;
            item.addEventListener("mouseenter", function(e) {
                if (item.getAttribute("data-slug") && item.getAttribute("data-id")) {
                    let slug = item.getAttribute("data-slug");
                    idContent = item.getAttribute("data-id");
                    let categoryHoverContent = document.querySelector('#category-hover-content-' + idContent);
                    let categoryHoverContentImage = document.querySelector('#category-hover-content-image-' + idContent);
                    categoryHoverContent.classList.remove('active')
                    Category.timeout = setTimeout(function() {
                        categoryHoverContent.classList.add('active')
                        categoryHoverContentImage.src = `${Category.images[slug].src}`;
                    }, 400);

                }

            })
            item.addEventListener("mouseout", function(e) {
                clearTimeout(Category.timeout);
                Category.timeout = null;
                Category.active = false;
            })
        });

        //se dopo qualche secondo non è attivo il mouse over rimuvo l'immagine
        let categoryHoverContent = document.querySelector('#category-hover-content-' + idContent);
        if (categoryHoverContent) {
            setInterval(function() {
                if (Category.active == false && Category.timeout == null) {
                    l
                    categoryHoverContent.classList.remove('active')
                }
            }, 3000);
        }


    }
}
export default Category;